export enum CardType {
    Hover,
    Simple
}